import { getAction, postAction } from '@/api/manage'

const BASE = '/api/plugin/workflow'

// 流程定义
export function flowDefineList(param) { return postAction(BASE + '/flowDefine/list', param) }
export function flowDefineSave(param) { return postAction(BASE + '/flowDefine/save', param) }
export function flowDefinePublish(id) { return postAction(BASE + '/flowDefine/publish', { id }) }
export function flowDefineStop(id) { return postAction(BASE + '/flowDefine/stop', { id }) }
export function flowDefineDelete(id) { return postAction(BASE + '/flowDefine/delete', { id }) }

// 发起 / 任务
export function workflowAdd(param) { return postAction(BASE + '/workflowTask/add', param) }
export function todoList(param) { return getAction(BASE + '/workflowTask/getToDoList', param) }
export function doneList(param) { return getAction(BASE + '/workflowTask/getHasDoList', param) }
export function submitList(param) { return getAction(BASE + '/workflowTask/getSubmitList', param) }
export function approve(param) { return postAction(BASE + '/workflowTask/approve', param) }
export function transfer(param) { return postAction(BASE + '/workflowTask/transfer', param) }

// 流程定义（含引用默认流程）
export function flowDefineGetByBillType(param) { return postAction(BASE + '/flowDefine/getByBillType', param) }
export function flowDefineGetById(param) { return postAction(BASE + '/flowDefine/getById', param) }

// 实例
export function cancelInstance(param) { return postAction(BASE + '/instance/cancel', param) }
export function getProgress(param) { return postAction(BASE + '/flow/getProgress', param) }